export default __webpack_public_path__ + "static/media/pause-button.236fc796.svg";